import React from 'react';
import { Dialog } from 'ui-components/dialog';
import { Button } from 'ui-components/button/button';
import { ReportIsReadyIcon } from 'components/assets/Icons/ReportIsReadyIcon';
import { MODAL_WIDTH } from 'ui-components/share-report-modal/share-report-modal';
import styles from './share-confirmation-modal.module.scss';

type UsersSharingData = {
    target: string;
    sharingList: string[];
};

type ShareConfirmationModalProps = {
    visible: boolean;
    onCloseModal: () => void;
    modalSharingUsers: UsersSharingData;
};

export const ShareConfirmationModal = ({ visible, onCloseModal, modalSharingUsers }: ShareConfirmationModalProps) => {
    const onCancelClick = () => {
        onCloseModal();
    };

    const sharingTarget = modalSharingUsers.target;
    const sharingList = modalSharingUsers.sharingList;
    const isUnshared = sharingTarget === 'user' && sharingList.length === 0;

    return (
        <Dialog
            centered
            destroyOnClose
            closable={false}
            className={styles.wrapper}
            visible={visible}
            footer={false}
            onCancel={onCancelClick}
            width={MODAL_WIDTH}

        >
            <div className={styles.content}>
                <ReportIsReadyIcon className={styles.icon} />
                <span className={styles.title}>{isUnshared ? 'Done!' : 'Sent!'}</span>
                <span className={styles.description}>
                    {isUnshared ? 
                        'Your report has been successfully unshared.' 
                        : 'Your report has been successfully shared.'}</span>
                <Button
                    className={styles.closeButton}
                    type="brand-primary-full"
                    onClick={onCancelClick}
                >
                    Close
                </Button>
            </div>
        </Dialog>
    );
};
